import { render, staticRenderFns } from "./EnrollmentWizard.vue?vue&type=template&id=ba84f2d0&scoped=true&"
import script from "./EnrollmentWizard.vue?vue&type=script&lang=js&"
export * from "./EnrollmentWizard.vue?vue&type=script&lang=js&"
import style0 from "./EnrollmentWizard.vue?vue&type=style&index=0&id=ba84f2d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba84f2d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VAlert,VForm})
